"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStaticComponentsLoaders = void 0;
function createStaticComponentsLoaders(_a) {
    var components = _a.components, context = _a.context;
    if (!components) {
        return {};
    }
    var statics = context.manifest.statics;
    var getAssets = function (componentName) {
        return context.manifest.components[componentName]
            ? context.manifest.components[componentName].assets
            : [];
    };
    var loaders = {};
    Object.keys(components).forEach(function (componentName) {
        var loader = function () {
            return Promise.resolve(components[componentName]);
        };
        loader.assets = getAssets(componentName);
        loader.isPartExist = function () {
            console.warn("Registry Warning \u2013 \"isPartExist\" is not valid for \"eager\" registry. Probably there is redundant call.");
            return false;
        };
        loader.statics = statics[componentName] ? statics[componentName] : {};
        loaders[componentName] = loader;
    });
    return loaders;
}
exports.createStaticComponentsLoaders = createStaticComponentsLoaders;
//# sourceMappingURL=createStaticComponentsLoaders.js.map